<template>
    <ContainerWithMenu>
        <div class="page-content">
            <div class="row margin-bottom-20">
                <div class="col-xs-7">
                    <h1 class="h2 margin-0">{{client.first_name}} {{client.last_name}}</h1>
                </div>
                <div class="col-xs-5">
                    <div class="btn-toolbar pull-right text-right">
                        <a class="btn btn-default"  href="" @click.prevent.stop="updateClientModalVisible=true"><i class="las la-user-edit"></i>{{ $t('common.edit') }}</a>
                        <a class="btn btn-primary btn-action-mobile" href="" @click.prevent.stop="newReservationModalVisible=true">
                            <i class="las la-calendar-plus"></i>
                            <span class="button-text">{{ $t('common.book') }}</span>
                        </a>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12 margin-bottom-20">
                    <div class="booking-section">
                        <div class="row">
                            <div class="col-xs-6 col-md-4">
                                <div class="form-group">
                                    <label for="customer_number">{{ $t('views.client_detail.client_number') }}</label>
                                    <p id="customer_number">{{client.fingerprint}}</p>
                                </div>
                            </div>
                            <div class="col-xs-6 col-md-4">
                                <div class="form-group">
                                    <label>{{ $t('common.first_name') }}</label>
                                    <p>
                                        <span id="customer_first_name">{{client.first_name}}</span> <span id="customer_last_name">{{client.last_name}}</span>
                                    </p>
                                </div>
                            </div>
                            <div class="col-xs-6 col-md-4">
                                <div class="form-group">
                                    <label for="customer_phone">{{ $t('common.phone') }}</label>
                                    <p id="customer_phone"><a :href="'tel:' + client.phone_number" target="_blank">{{phoneNumberStr}}</a></p>
                                </div>
                            </div>
                            <div class="col-xs-6 col-md-4">
                                <div class="form-group">
                                    <label for="customer_email">{{ $t('common.email') }}</label>
                                    <p id="customer_email"><a :href="'mailto:' + client.email" target="_blank">{{client.email}}</a></p>
                                </div>
                            </div>
                            <div class="col-xs-6 col-md-4" v-show="isAcsiCompany">
                                <div class="form-group">
                                    <label for="customer_acsi">{{ $t('client.acsi_card') }}</label>
                                    <p id="customer_acsi">{{getStringOrNA(client.acsi_card)}}</p>
                                </div>
                            </div>
                            <div class="col-xs-6 col-md-4" >
                                <div class="form-group">
                                    <label for="customer_note">{{ $t('client.note') }}</label>
                                    <p id="customer_note">{{getStringOrNA(client.note)}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12">
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <div class="row">
                                <div class="col-xs-6">
                                    {{ $t('views.client_detail.statistics') }}
                                </div>

                            </div>
                        </div>
                        <div class="panel-body">
                            <p class="margin-0" v-html="$t('views.client_detail.statistics_body', { first_name: client.first_name, date: getDataString(client.created_date), reservation_count: client.reservation_count, revenue_currency: getCurrencySymbolFromString(revenue_currency), revenue_value: client.revenue_value})"></p>
                        </div>
                    </div>
                </div>
            </div>

          <ul class="nav nav-tabs margin-bottom-20">
            <li role="presentation" :class="{ 'active' : selectedTab === TAB.APPOINTMENTS}"><a href="" role="tab" data-toggle="tab" @click.prevent.stop="appointmentsTabClick">{{ $t('views.client_detail.appointments') }}</a></li>
            <li role="presentation" :class="{ 'active' : selectedTab === TAB.RESERVATIONS}"><a href="" role="tab" data-toggle="tab" @click.prevent.stop="reservationTabClick">{{ $t('views.client_detail.reservations') }}</a></li>
            <li role="presentation" :class="{ 'active' : selectedTab === TAB.SUBSCRIPTIONS}"><a href="" role="tab" data-toggle="tab" @click.prevent.stop="subscriptionsTabClick">{{ $t('views.client_detail.subscriptions') }}</a></li>
            <li role="presentation" :class="{ 'active' : selectedTab === TAB.ORDERS}"><a href="" role="tab" data-toggle="tab" @click.prevent.stop="ordersTabClick">{{ $t('views.client_detail.orders') }}</a></li>
          </ul>
          <div class="tab-content">
            <div role="tabpanel" class="tab-pane padding-top-20" :class="{ 'active' : selectedTab === TAB.APPOINTMENTS}" id="appointments">
              <h3 class="margin-bottom-20">{{ $t('views.client_detail.appointments') }}</h3>
                <AppointmentsTable :selected-client-id="client.id" v-if="appointments.length > 0" :appointments="appointments"></AppointmentsTable>
                <div v-else>
                    <span class="text-muted">{{ $t('views.client_detail.appointments_not_found') }}</span>
                </div>
            </div>
            <div role="tabpanel" class="tab-pane padding-top-20" :class="{ 'active' : selectedTab === TAB.RESERVATIONS}" id="reservations">
                <h3 class="margin-bottom-20">{{ $t('views.client_detail.reservations') }}</h3>
                <div class="table-responsive" v-if="reservations && reservations.length > 0">
                    <ReservationTable :show-user="false" :reservations="reservations"></ReservationTable>
                </div>
                <div v-else>
                    <span class="text-muted">{{ $t('views.client_detail.reservations_not_found') }}</span>
                </div>
            </div>
            <div role="tabpanel" class="tab-pane padding-top-20" :class="{ 'active' : selectedTab === TAB.SUBSCRIPTIONS}" id="subscriptions">
                <h3 class="margin-bottom-20">{{ $t('views.client_detail.subscriptions') }}</h3>
                <a class="btn btn-default margin-bottom-20" href="" @click.prevent.stop="purchaseSubscriptionModalVisible=true"><i class="las la-plus"></i>{{ $t('common.buy_subscription') }}</a>
                <div class="table-responsive" v-if="subscriptions.length > 0">
                    <SubscriptionsTable :subscriptions="subscriptions"></SubscriptionsTable>
                </div>
                <div v-else>
                    <span class="text-muted">{{ $t('views.client_detail.subscriptions_not_found') }}</span>
                </div>
            </div>
            <div role="tabpanel" class="tab-pane padding-top-20" :class="{ 'active' : selectedTab === TAB.ORDERS}" id="orders">
                <h3 class="margin-bottom-20">{{ $t('views.client_detail.orders') }}</h3>
                <div class="table-responsive" v-if="orders.length > 0">
                    <OrdersTable :orders="orders" @show-receipt="showReceipt"></OrdersTable>
                </div>
                <div v-else>
                    <span class="text-muted">{{ $t('views.client_detail.orders_not_found') }}</span>
                </div>
            </div>
        </div>

        </div>
        <SpinnerLoader v-show="loading"></SpinnerLoader>

        <PurchaseSubscriptionModal v-show="purchaseSubscriptionModalVisible"
                                   :visible="purchaseSubscriptionModalVisible"
                                   @success-purchase-subscription="onSuccessPurchaseSubscription"
                                   @close-subscription-modal="purchaseSubscriptionModalVisible=false"></PurchaseSubscriptionModal>

        <NewReservationModal v-show="newReservationModalVisible"
                             :visible="newReservationModalVisible"
                             :client-id="client.id"
                             @success-new-reservation="onSuccessNewReservation"
                             @close-new-reservation-modal="newReservationModalVisible=false"></NewReservationModal>

        <UpdateClientModal v-show="updateClientModalVisible"
                           :visible="updateClientModalVisible"
                           :client="client"
                           @close-client-modal="updateClientModalVisible=false"
                           @success-update-client="onSuccessUpdateClient"></UpdateClientModal>

        <ReceiptModal :order="selectedOrder" v-show="showReceiptModal" :visible="showReceiptModal" @close-receipt-modal="showReceiptModal=false"></ReceiptModal>

    </ContainerWithMenu>
</template>

<script>
    import parsePhoneNumber from 'libphonenumber-js'
    import SubscriptionsTable from "@/components/subscription/SubscriptionsTable";

    import ContainerWithMenu from "../components/container/ContainerWithMenu";
    import {getClientDetail} from "../api";
    import SpinnerLoader from "../components/common/SpinnerLoader";
    import {Utils} from "../common/utils";
    import PurchaseSubscriptionModal from "../components/modal/PurchaseSubscriptionModal";
    import NewReservationModal from "../components/modal/NewReservationModal";
    import ReservationTable from "@/components/reservation/ReservationTable";
    import AppointmentsTable from "@/components/appointment/AppointmentsTable";
    import {getClientAppointments, getClientOrders, getClientReservations, getClientSubscription} from "@/api";
    import OrdersTable from "@/components/order/OrdersTable";
    import UpdateClientModal from "@/components/modal/UpdateClientModal";
    import {StorageHelper} from "../common/storageHelper";
    import ReceiptModal from "../components/modal/ReceiptModal";

    export default {
        title: 'Cliente nel dettaglio',
        name: "ClientDetail",
        components: {
            UpdateClientModal,
            OrdersTable, SubscriptionsTable, AppointmentsTable, ContainerWithMenu, SpinnerLoader,
            PurchaseSubscriptionModal, NewReservationModal, ReservationTable, ReceiptModal},
        data: function () {
            return {
                isAcsiCompany: false,
                loading: false,
                client: {},
                revenue_currency: "",
                appointments: [],
                reservations: [],
                orders: [],
                subscriptions: [],
                selectedTab: 0,
                purchaseSubscriptionModalVisible : false,
                newReservationModalVisible: false,
                updateClientModalVisible: false,
                renderReservationModal: true,
                TAB : {
                    APPOINTMENTS: 0,
                    RESERVATIONS: 1,
                    SUBSCRIPTIONS: 2,
                    ORDERS: 3
                },
                showReceiptModal: false,
                selectedOrder: {}
            }
        },
        methods: {
            showReceipt(order) {
                this.selectedOrder = order;
                this.showReceiptModal = true;
            },
            getStringOrNA(string) {
              return Utils.getStringOrNA(string)
            },
            getClassLabelReservationState(state) {
                return Utils.getClassLabelReservationState(state)
            },
            getStringReservationState(state) {
                return Utils.getStringReservationState(state)
            },
            getStringPaymentMode(payment_mode) {
                return Utils.getStringPaymentMode(payment_mode)
            },
            getStringChannelMode(channel) {
                return Utils.getStringChannelMode(channel)
            },
            getDataString(date) {
                return Utils.getShortDateStringFromISO(date)
            },
            getDataExtendString(date){
                return Utils.getDateStringFromISO(date)
            },
            onSuccessPurchaseSubscription() {
                this.purchaseSubscriptionModalVisible = false;
                this.getClientDetail();
                this.renderReservationModal = false;

                this.$nextTick(() => {
                    this.renderReservationModal = true;
                });
            },
            async getClientDetail() {
                this.loading = true;
                try {
                    this.client = await getClientDetail(this.$route.params.id);

                    switch (this.selectedTab) {
                        case this.TAB.SUBSCRIPTIONS:
                            await this.getSubscriptionsClient();
                            break;
                        case this.TAB.ORDERS:
                            await this.getOrdersClient();
                            break;
                        case this.TAB.RESERVATIONS:
                            await this.getReservationsClient();
                            break;
                        case this.TAB.APPOINTMENTS:
                            await this.getAppointmentClient();
                            break;
                    }
                    this.loading = false;
                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            },
            onSuccessNewReservation() {
                this.newReservationModalVisible = false;
                this.getClientDetail();
            },
            onSuccessUpdateClient() {
                this.updateClientModalVisible = false;
                this.getClientDetail();
            },
            appointmentsTabClick() {
                this.selectedTab = this.TAB.APPOINTMENTS;
                this.getAppointmentClient();
            },
            reservationTabClick() {
                this.selectedTab = this.TAB.RESERVATIONS;
               this.getReservationsClient();
            },
            subscriptionsTabClick() {
                this.selectedTab = this.TAB.SUBSCRIPTIONS;
                this.getSubscriptionsClient();
            },
            ordersTabClick() {
                this.selectedTab = this.TAB.ORDERS;
                this.getOrdersClient();
            },
            async getAppointmentClient() {
                this.loading = true;
                try {
                    this.appointments = await getClientAppointments(this.$route.params.id);
                    this.loading = false;
                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            },
            async getReservationsClient() {
                this.loading = true;
                try {
                    this.reservations = await getClientReservations(this.$route.params.id);
                    this.loading = false;
                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            },
            async getSubscriptionsClient() {
                this.loading = true;
                try {
                    this.subscriptions = await getClientSubscription(this.$route.params.id);
                    this.loading = false;
                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            },
            async getOrdersClient() {
                this.loading = true;
                try {
                    this.orders = await getClientOrders(this.$route.params.id);
                    this.loading = false;
                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            },
            getCurrencySymbolFromString(currency) {
                return Utils.getCurrencySymbolFromString(currency)
            }
        },
        computed: {
            phoneNumberStr() {
                if (this.client.phone_number) {
                    const phoneNumber = parsePhoneNumber(this.client.phone_number);
                    return "+" + phoneNumber.countryCallingCode + " " + phoneNumber.nationalNumber;
                }

                return ""
            }
        },
        mounted() {
            const user = StorageHelper.getUser();
            this.isAcsiCompany = user.company.is_acsi;
            this.revenue_currency = Utils.getCompanyCurrency();
            this.getClientDetail();
            this.getAppointmentClient();
        }
    }
</script>
